module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-link-shadow text-center"
  }, [_c('div', {
    staticClass: "block-content block-content-full block-sticky-options pt-30"
  }, [_c('div', {
    staticClass: "block-options"
  }, [_c('b-dropdown', {
    staticClass: "dropdown-no-btn",
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-v"
  })]), _vm._v(" "), (_vm.isImportChannel) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncProducts
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag mr-5"
  }), _vm._v("Importeer Producten\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isImportChannel && _vm.salesChannel.key.includes('vm')) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncStocks
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag mr-5"
  }), _vm._v("Synchroniseer voorraad\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isImportChannel) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncOrders
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shopping-cart mr-5"
  }), _vm._v("Importeer Bestellingen\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isImportChannel) ? _c('b-dropdown-item', {
    attrs: {
      "disabled": _vm.syncing
    },
    on: {
      "click": _vm.syncRefunds
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shopping-cart mr-5"
  }), _vm._v("Importeer Retours\n        ")]) : _vm._e()], 2)], 1), _vm._v(" "), _c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": '/static/img/sales-channels/' + _vm.salesChannel.type + '.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('div', {
    staticClass: "font-w600 mb-5"
  }, [_vm._v(_vm._s(_vm.salesChannel.name))]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v(_vm._s(_vm._f("type")(_vm.salesChannel.type)))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row items-push text-center"
  }, [(_vm.isImportChannel) ? _c('div', {
    staticClass: "col-12"
  }, [(_vm.syncing) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Import starten...")])]) : _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Laatste import: " + _vm._s(_vm._f("moment")(_vm.salesChannel.date_last_synced, 'calendar')))])])]) : _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm text-muted"
  }, [_vm._v("Import n.v.t.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-like fa-2x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb3903f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sales-channels/SalesChannelWidget.vue
// module id = 696
// module chunks = 1